import React from 'react';

const DashboardHome = () => {
    return (
        <div>
            hello peter
        </div>
    );
};

export default DashboardHome;